/**
 * Created by sung on 2017-02-07.
 */
import {CommonModule} from "@angular/common";
import {NgModule,Component, OnInit} from '@angular/core';
import {HttpModule,URLSearchParams} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";

import {SelectItem} from 'primeng/primeng';
import { DataTableModule, ButtonModule,PaginatorModule, PanelModule, DropdownModule } from 'primeng/primeng';
import {FormsModule, FormGroup, ReactiveFormsModule, FormBuilder, FormControl, Validators } from "@angular/forms";

import {ExDialogModule} from "../../component/dialog.component";
import {MamAdminService} from '../../service/mam_service.component';
import {SearchModule} from "../../component/search.component";

import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import {ProdDevice} from "../../model/product_device";
import { OSType,Status } from '../../model/enumModel';
import {Logger, Options, Level } from "angular2-logger/core";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe";
import {TranslateServiceForm} from "../../translate/translate.service"; // ADD THIS



@Component({
  selector:'device-type-management',
  templateUrl:'./device_type_management.html'
})
export class DeviceTypeManagementComponent implements OnInit {

  private product_device : ProdDevice[] = [];
  private company_list : ThirdPartyCompany[] = [];

  totalRecord: number;
  searchIDs: SelectItem[];
  osItems : SelectItem[];
  statusItems : SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax:number =10;

  dialogWidth : number = 600;
  addShow : boolean = false;
  addUpdateShow : boolean = false;
  addForm : FormGroup;

  selectedOsName : string;
  selectedStatus : Status;

  selectedItems : any[]=[];
  selectedCompany : any;
  translate : TranslateServiceForm;
  ngOnInit() {
    this.getCompanyList();
    this.getProductDeviceList(1,10,"","","");
    this.selectedOsName = 'Android';
    this.selectedStatus = Status.ACTIVE;
    //this.loadAttributeType();
  }

  constructor(private service: MamAdminService, private fb: FormBuilder, private logger : Logger, private _translate : TranslateServiceForm){
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_DeviceType'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('LANG_VendorName'), value: 'vendorName'});
    this.searchIDs.push({label: this.translate.instant('LANG_ModelName'), value: 'modelName'});
    this.searchIDs.push({label: this.translate.instant('LANG_OsName'), value: 'osName'});
    this.searchIDs.push({label: this.translate.instant('ProductDeviceStatus'), value: 'status'});

    this.osItems = [];
    this.osItems.push({label: 'Android', value: 'Android'});
    this.osItems.push({label: 'iOS', value: 'IOS'});
    this.osItems.push({label: 'Windows Mobile', value: 'Windows Mobile'});
    this.osItems.push({label: 'Windows Desktop', value: 'Windows Desktop'});

    this.statusItems = [];
    this.statusItems.push({label: this.translate.instant('LANG_Activation'), value: Status.ACTIVE});
    this.statusItems.push({label: this.translate.instant('LANG_Disabled'), value: Status.PASSIVE});

    this.dateIsTrue = false;

    this.addForm = this.fb.group({
      'id' : new FormControl(''),
      'name' : new FormControl('',Validators.required),
      'modelName' : new FormControl('',Validators.required),
      'osVersion' : new FormControl('',Validators.required),
      'status' : new FormControl('', Validators.required),
      'vendorName' : new FormControl('', Validators.required),
      'osName' : new FormControl('', Validators.required),
      'binaryFilePath' : new FormControl('')
    });
  }

  /*private loadAttributeType():void{
      var url_path = "/mgr/system/attribute/company/type/all";
      var p_params = new URLSearchParams();
      p_params.set("companyId" ,String(3));;
      this.service.get(url_path,null,null).subscribe(
            value => {
                this.logger.debug("loadAttributeType : ", value);
            }, error=>{this.logger.error("-- error : " + error);}
        )
  }*/
  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    this.getProductDeviceList(1,this.pageMax,this.searchText, "true", this.searchId);

  }

  



  paginate(event) {
    this.pageMax = event.rows;
    if (this.searchIsTrue) {

      this.getProductDeviceList(event.page + 1, event.rows,this.searchText, "true", this.searchId);
    } else {

      this.getProductDeviceList(event.page + 1, event.rows,"", '',"");
    }

  }

  getCompanyList() {
      this.service.getCompanyList(null, null).subscribe(
          value => {
            this.logger.debug("value :", value);
            this.company_list = value.content;
            this.logger.debug("-- company_list :", value.content);
          },
          error => {
            this.logger.error("-- error : " + error);
          },
          () => {
            this.logger.info("-- complate : ");
          }
        )
  }

  getProductDeviceList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getProductDeviceList(page, max, search, like, field).subscribe(
        value => {
          this.table_list = value.rows;
          this.totalRecord = value.total;
          for(var i=0; i < this.table_list.length; i++) {
            if(this.table_list[i].status == "ACTIVE") {
              this.table_list[i].status = this.translate.instant('LANG_Activation');
            } else {
              this.table_list[i].status = this.translate.instant('LANG_Disabled');
            }

          }
          this.logger.debug("-- getProductDevice_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
      )
  }

  insertProductDevice(product_model : any) {
    this.service.insertProductDevice(product_model).subscribe(
        value => {
          this.table_list = value.rows;
          this.totalRecord = value.total;
          this.logger.debug("-- notice_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
          this.getProductDeviceList(1,10,'','','');
        }
      )
  }

  updateProductDevice(id:number, product_model : any) {
    this.service.updateProductDevice(id, product_model).subscribe(
        value => {
          let result = value;
          this.logger.debug("-- result :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
          this.getProductDeviceList(1,10,'','','');
        }
      )
  }

  deleteProductDevice(id:string) {
    this.service.deleteProductDevice(id).subscribe(
      value => {
        let result = value;
        this.logger.debug("-- result :", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
        this.getProductDeviceList(1,10,'','','');
      }
    )
  }



  showDialogToAdd(){
   this.addShow = true;
    this.addForm.controls['id'].setValue('');
    this.addForm.controls['name'].setValue('');
    this.addForm.controls['vendorName'].setValue('');
    this.addForm.controls['osName'].setValue('Android');
    this.addForm.controls['modelName'].setValue('');
    this.addForm.controls['osVersion'].setValue('');
    this.addForm.controls['binaryFilePath'].setValue('');
  }

  showDialogToUpdate() {
    this.logger.debug("selectedItem",this.selectedItems);
    if(this.selectedItems && this.selectedItems.length == 1){
      this.addUpdateShow = true;
      this.selectedItems.forEach(item=>{
        this.addForm.controls['id'].setValue(item.id);
        this.addForm.controls['name'].setValue(item.name);
        this.addForm.controls['vendorName'].setValue(item.vendorName);
        this.addForm.controls['modelName'].setValue(item.modelName);
        this.addForm.controls['osVersion'].setValue(item.osVersion);
        this.addForm.controls['binaryFilePath'].setValue(item.binaryFilePath);
        this.selectedCompany = item.company;
        this.selectedOsName = item.osName;
        if(item.status == this.translate.instant('LANG_Disabled')){
          this.selectedStatus = Status.PASSIVE;
        } else {
          this.selectedStatus = Status.ACTIVE;
        }
      });


    }else{
      alert(this.translate.instant('MESSAGE_Select_Only_One'));
    }

  }

  showDialogToDelete() {
    this.logger.debug("삭~제");
    let ids = [];
    if(this.selectedItems && this.selectedItems.length >0){
      this.selectedItems.forEach(item => {
        ids.push(item.id);
      });
    }
    this.deleteProductDevice(ids.join(","));
  }

  onSubmit(data, type, id) {
    this.logger.debug("type :", type);
    this.logger.debug("data :", data);

    var product_model = { name : data.name, binaryFilePath  : data.binaryFilePath, modelName  : data.modelName,
      osName : this.selectedOsName, osVersion  :  data.osVersion, vendorName : data.vendorName, status : this.selectedStatus, company: this.selectedCompany
    }
    if(type == 'add') {
      this.insertProductDevice(product_model);
    } else if (type == 'update') {
      this.updateProductDevice(data.id, product_model);
    }
    this.selectedItems = [];

    this.addShow = false;
    this.addUpdateShow = false;

  }

  onOsChange(event) {
    this.logger.debug("event1 : ", event);
  }

  onStatusChange(event) {
    this.logger.debug("event2 : ", event);
  }

  /*onRowSelect(event) {
    this.logger.debug("event",event);
    this.addForm.controls['id'].setValue(event.data.id);
    this.addForm.controls['name'].setValue(event.data.name);
    this.addForm.controls['vendorName'].setValue(event.data.vendorName);
    this.addForm.controls['modelName'].setValue(event.data.modelName);
    this.addForm.controls['osVersion'].setValue(event.data.osVersion);
    this.addForm.controls['binaryFilePath'].setValue(event.data.binaryFilePath);
    this.selectedOsName = event.data.osName;
    if(event.data.status == 'PASSIVE'){
      this.selectedStatus = Status.PASSIVE;
    } else {
      this.selectedStatus = Status.ACTIVE;
    }
  }*/

  get diagnostic() { return JSON.stringify(this.addForm.value);}

  cancel(){
    this.addShow =false;
    this.addUpdateShow = false;
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.logger.debug("combo - select :" , this.selectedCompany);
  }
}

@NgModule({
  imports:[ ReactiveFormsModule, DataTableModule, PanelModule, ButtonModule, CommonModule,BrowserModule,HttpModule, FormsModule,SearchModule,PaginatorModule, ExDialogModule, DropdownModule, CompanyDropDownListModule, TranslatePipeMoudle],
  declarations:[DeviceTypeManagementComponent],
  exports:[DeviceTypeManagementComponent],
  providers:[MamAdminService]
})
export class DeviceTypeManagementModule{

}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/system/device_type_management.ts